import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
export const STREAM__DELETE_ITEMS = 'STREAM__DELETE_ITEMS';
export const STREAM__MOVE_ITEM = 'STREAM__MOVE_ITEM';
export const STREAM__REPLACE_ITEM = 'STREAM__REPLACE_ITEM';
export const STREAM__FETCH_FAILURE = 'STREAM__FETCH_FAILURE';
export const STREAM__FETCH_RETRY = 'STREAM__FETCH_RETRY';
export const STREAM__DELETE_STREAM = 'STREAM__DELETE_STREAM';
export const STREAM__SET_PARAM = 'STREAM__SET_PARAM';
export const STREAM__INSERT_ITEMS = 'STREAM__INSERT_ITEMS';
import { createAction } from 'redux-actions';
export const initializeIfNeeded = createAction('STREAM__INIT_IF_NEEDED', (streamId, config)=>_object_spread({
        streamId
    }, config));
export const fetchNext = createAction('STREAM__FETCH_NEXT', (streamId)=>({
        streamId
    }));
export const fetchAll = createAction('STREAM__FETCH_ALL', (streamId)=>({
        streamId
    }));
export const fetchPrevious = createAction('STREAM__FETCH_PREVIOUS', (streamId)=>({
        streamId
    }));
export const fetchRetry = createAction(STREAM__FETCH_RETRY, (streamId)=>({
        streamId
    }));
export function fetch(streamId, direction) {
    switch(direction){
        case 'prev':
            return fetchPrevious(streamId);
        case 'all':
            return fetchAll(streamId);
        case 'retry':
            return fetchRetry(streamId);
        case 'next':
        default:
            return fetchNext(streamId);
    }
}
export const deleteItem = ({ streamId, item, doNotUpdateNextOffset, isEqual })=>deleteItems({
        streamId,
        items: [
            item
        ],
        doNotUpdateNextOffset,
        isEqual
    });
export const deleteItems = ({ streamId, items, doNotUpdateNextOffset, isEqual })=>({
        type: STREAM__DELETE_ITEMS,
        streamId,
        items,
        doNotUpdateNextOffset,
        isEqual
    });
export const moveItem = ({ streamId, item, position })=>({
        type: STREAM__MOVE_ITEM,
        streamId,
        item,
        position
    });
export const fetchFailure = ({ streamId, fetchType, errorMsg })=>({
        type: STREAM__FETCH_FAILURE,
        streamId,
        fetchType,
        errorMsg
    });
export const deleteStream = (streamId)=>({
        type: STREAM__DELETE_STREAM,
        streamId
    });
export const replaceItem = ({ streamId, newItem, predicate })=>({
        type: STREAM__REPLACE_ITEM,
        streamId,
        newItem,
        predicate
    });
export const insertItemsAtOffsets = ({ streamId, newItems, deduplicate, doNotUpdateNextOffset })=>({
        type: STREAM__INSERT_ITEMS,
        streamId,
        newItems,
        deduplicate,
        doNotUpdateNextOffset
    });
export const setParam = ({ streamId, paramType, paramValue })=>({
        type: STREAM__SET_PARAM,
        streamId,
        paramType,
        paramValue
    });
export const replaceItems = createAction('STREAM__REPLACE_ITEMS', (streamId, updatedItems)=>({
        streamId,
        updatedItems
    }));
// use when you need to mark a stream for fetchinng without actually dispatching the fetch action
// eg. in storybook or some odd saga edge cases
export const markAsFetching = createAction(`STREAM__MARK_AS_FETCHING`, (streamId)=>({
        streamId
    }));
export const markAsCancelled = createAction(`STREAM__MARK_AS_CANCELLED`, (streamId)=>({
        streamId
    }));
export const cancelFetchForStream = createAction(`STREAM__CANCEL_FETCH`, (streamId)=>({
        streamId
    }));
